import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import discoveryPageHtml from "./discoveryPageHtml";
import "./DiscoveryCallPage.css";

function DiscoveryCallPage() {
  const iframeRef = useRef(null);
  const cleanupRef = useRef(null);
  const [frameHeight, setFrameHeight] = useState("100vh");

  useEffect(() => {
    document.body.classList.add("discovery-static-active");

    return () => {
      document.body.classList.remove("discovery-static-active");
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
    };
  }, []);

  const syncFrameHeight = useCallback(() => {
    const iframe = iframeRef.current;
    const frameWindow = iframe?.contentWindow;
    const frameDocument = iframe?.contentDocument;

    if (!frameWindow || !frameDocument) return;

    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    const measure = () => {
      const body = frameDocument.body;
      const root = frameDocument.documentElement;
      const nextHeight = Math.max(
        body?.scrollHeight || 0,
        body?.offsetHeight || 0,
        root?.scrollHeight || 0,
        root?.offsetHeight || 0,
        window.innerHeight
      );

      setFrameHeight(`${nextHeight}px`);
    };

    measure();

    const observers = [];
    if ("ResizeObserver" in window) {
      const observer = new ResizeObserver(measure);
      if (frameDocument.body) observer.observe(frameDocument.body);
      if (frameDocument.documentElement) observer.observe(frameDocument.documentElement);
      observers.push(observer);
    }

    const intervalId = window.setInterval(measure, 750);
    frameWindow.addEventListener("resize", measure);

    cleanupRef.current = () => {
      observers.forEach((observer) => observer.disconnect());
      window.clearInterval(intervalId);
      frameWindow.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <main className="discovery-static-page">
      <Helmet>
        <title>Brew Your Brand | Discovery Call</title>
        <meta
          name="description"
          content="Book a Brew Your Brand Discovery Call to understand where your brand stands before investing in marketing, design, or growth."
        />
      </Helmet>
      <iframe
        ref={iframeRef}
        className="discovery-static-frame"
        title="Brew Your Brand Discovery Call"
        srcDoc={discoveryPageHtml}
        onLoad={syncFrameHeight}
        style={{ height: frameHeight }}
      />
    </main>
  );
}

export default DiscoveryCallPage;
